import { css, cva } from '@/styled-system/css';

export const spinnerStyles = cva({
  // TODO: use animation tokens when available
  base: {
    animation: 'spin 0.5s linear infinite',
    stroke: 'currentColor',

    _motionReduce: {
      animation: 'none',
    },
  },
  variants: {
    onImpact: {
      false: {
        color: 'icon.accent.brand.hero',
      },
      true: {
        color: 'icon.onHero.neutral',
      },
    },
    fixedMode: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      fixedMode: true,
      onImpact: false,
      css: {
        color: 'icon.accent.brand.hero-fixed',
      },
    },
    {
      fixedMode: true,
      onImpact: true,
      css: {
        color: 'icon.onHero.neutral-fixed',
      },
    },
  ],
});

export const spinnerFillStyle = css.raw({
  width: '100%',
  height: '100%',
  backgroundImage: 'conic-gradient(from 90deg at 50% 66%, transparent 20deg, currentColor 360deg)',
});
